<template>
  <Transition name="volver-arriba">
    <button
      v-if="visible"
      type="button"
      class="volver-arriba fixed right-5 bottom-5 z-40 sm:right-8 sm:bottom-8"
      aria-label="Volver al inicio de la página"
      @click="volver"
    >
      <IconArrowUp aria-hidden="true" />
    </button>
  </Transition>
</template>

<script>
import { IconArrowUp } from '@tabler/icons-vue'

/**
 * HomeVolverArriba
 * Botón flotante exclusivo de la portada: aparece cuando el hero (section#hero) sale de pantalla
 * y lleva de vuelta a él con scroll suave (instantáneo con movimiento reducido), para no obligar a
 * subir a pulso desde las secciones inferiores.
 */
export default {
  name: 'HomeVolverArriba',
  components: { IconArrowUp },
  data() {
    return {
      visible: false
    }
  },
  mounted() {
    const hero = document.getElementById('hero')
    if (hero && 'IntersectionObserver' in window) {
      this.observador = new IntersectionObserver(([entrada]) => {
        this.visible = !entrada.isIntersecting
      })
      this.observador.observe(hero)
    }
  },
  beforeUnmount() {
    if (this.observador) {
      this.observador.disconnect()
    }
  },
  methods: {
    volver() {
      const hero = document.getElementById('hero')
      if (!hero) return
      const reducirMovimiento = window.matchMedia('(prefers-reduced-motion: reduce)').matches
      hero.scrollIntoView({ behavior: reducirMovimiento ? 'auto' : 'smooth' })
    }
  }
}
</script>

<style scoped>
.volver-arriba {
  display: grid;
  width: 3rem;
  height: 3rem;
  place-items: center;
  border-radius: 9999px;
  background-color: var(--color-primary);
  color: #FFFFFF;
  box-shadow: 0 12px 28px rgb(41 46 255 / 0.35);
  cursor: pointer;
  transition:
    background-color var(--duration-gob) var(--ease-gob-out),
    transform var(--duration-gob) var(--ease-gob-out);
}

.volver-arriba:hover {
  background-color: var(--color-primary-dark);
  transform: translateY(-2px);
}

.volver-arriba svg {
  width: 1.5rem;
  height: 1.5rem;
}

.volver-arriba-enter-active,
.volver-arriba-leave-active {
  transition:
    opacity var(--duration-gob) var(--ease-gob-out),
    transform var(--duration-gob) var(--ease-gob-out);
}

.volver-arriba-enter-from,
.volver-arriba-leave-to {
  opacity: 0;
  transform: translateY(0.5rem);
}

@media (prefers-reduced-motion: reduce) {
  .volver-arriba {
    transition: none;
  }

  .volver-arriba:hover {
    transform: none;
  }

  .volver-arriba-enter-active,
  .volver-arriba-leave-active {
    transition: none;
  }
}
</style>
